var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 5C22.75 2.929 21.071 1.25 19 1.25H5C2.929 1.25 1.25 2.929 1.25 5V19C1.25 21.071 2.929 22.75 5 22.75H19C21.071 22.75 22.75 21.071 22.75 19V5ZM21.25 5V19C21.25 20.243 20.243 21.25 19 21.25H5C3.757 21.25 2.75 20.243 2.75 19V5C2.75 3.757 3.757 2.75 5 2.75H19C20.243 2.75 21.25 3.757 21.25 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6.25H2C1.586 6.25 1.25 6.586 1.25 7C1.25 7.414 1.586 7.75 2 7.75H22C22.414 7.75 22.75 7.414 22.75 7C22.75 6.586 22.414 6.25 22 6.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.25C13.1642 5.25 13.5 4.91421 13.5 4.5C13.5 4.08579 13.1642 3.75 12.75 3.75C12.3358 3.75 12 4.08579 12 4.5C12 4.91421 12.3358 5.25 12.75 5.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.25C15.9142 5.25 16.25 4.91421 16.25 4.5C16.25 4.08579 15.9142 3.75 15.5 3.75C15.0858 3.75 14.75 4.08579 14.75 4.5C14.75 4.91421 15.0858 5.25 15.5 5.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 5.25C18.6642 5.25 19 4.91421 19 4.5C19 4.08579 18.6642 3.75 18.25 3.75C17.8358 3.75 17.5 4.08579 17.5 4.5C17.5 4.91421 17.8358 5.25 18.25 5.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4881 10.6629L10.0881 17.8629C9.95805 18.2559 10.1701 18.6809 10.5631 18.8119C10.9561 18.9419 11.3811 18.7299 11.5121 18.3369L13.9121 11.1369C14.0421 10.7439 13.8301 10.3189 13.4371 10.1879C13.0441 10.0579 12.6191 10.2699 12.4881 10.6629Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.57 12.6301L16.439 14.5001L14.57 16.3701C14.277 16.6621 14.277 17.1381 14.57 17.4301C14.862 17.7231 15.338 17.7231 15.63 17.4301L18.03 15.0301C18.323 14.7371 18.323 14.2631 18.03 13.9701L15.63 11.5701C15.338 11.2771 14.862 11.2771 14.57 11.5701C14.277 11.8621 14.277 12.3381 14.57 12.6301Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36999 11.5701L5.96999 13.9701C5.67699 14.2631 5.67699 14.7371 5.96999 15.0301L8.36999 17.4301C8.66199 17.7231 9.13799 17.7231 9.42999 17.4301C9.72299 17.1381 9.72299 16.6621 9.42999 16.3701L7.56099 14.5001L9.42999 12.6301C9.72299 12.3381 9.72299 11.8621 9.42999 11.5701C9.13799 11.2771 8.66199 11.2771 8.36999 11.5701Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.c2ba4d60c77fb77cadaf1e707c74071c.svg";
export { ForwardRef as ReactComponent };